export default __webpack_public_path__ + "static/media/03.a756752e.webp";